import clsx from "clsx";
import React from "react";
import { criterionTabsType } from "../../../../common/types/search/search";

interface CriterionTabsProps {
	tabsKey: string;
	input: string;
	items?: {
		key: string;
		value: string;
	}[];
	currentInput: criterionTabsType;
	onInputChange: (input: criterionTabsType) => void;
}

export default function CriterionTabs({
	tabsKey,
	input,
	items,
	currentInput,
	onInputChange,
}: CriterionTabsProps) {
	if (!items) {
		return null;
	}

	const onChange = (value: string) => {
		onInputChange(currentInput.set(tabsKey, value));
	};

	const tabs = items.map((item) => {
		const { key, value } = item;
		const classes = clsx("btn--tab", { active: key === input });

		return (
			<button
				key={key}
				type="button"
				className={classes}
				data-criterion={true}
				onClick={() => onChange(key)}
			>
				{value}
			</button>
		);
	});

	return <div className="criterion__tabs flex">{tabs}</div>;
}
